import Vue from 'vue'
import App from './App.vue'
// 引入路由对象
import router from './router.js'
// 引入axios对象
import axios from 'axios'
import VueAxios from 'vue-axios'
// 引入公共样式文件
import './assets/css/base.css'
// 引入ElementUI
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './theme/element/theme/index.css'
//引入复制到剪贴板
import VueClipboard from 'vue-clipboard2'
//引入工具类文件
import utils from './utils/common-utlis.js'
import request from './utils/request-utils.js'
import publicMethods from './utils/public-methods.js'
import currency from './utils/currency-utils.js'
import { getParam } from './utils/api-utils/api-params.js'
import { getCustomerInfo } from './utils/api-utils/api-customer.js'

// 非父子组件之间传值及事件广播监听中转
import eventBus from './utils/event-bus.js'
import moment from 'moment'
import {
	constant,
	allUserSettingKeyList
} from './config.js'

let isFirsrLoad = true

Vue.prototype.$moment = moment;
Vue.prototype.$utils = utils;
Vue.prototype.$request = request;
Vue.prototype.$public = publicMethods;
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$currency = currency;

Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.use(VueClipboard);

// 提示开关
Vue.config.productionTip = false
Vue.config.devtools = true //生产环境也可使用vue-devtools工具

//全局路由前置守卫，判断链接中是否有吉客号
router.beforeEach(async (to, from, next) => {
	if (parent != window) {
		try {
			window.parent.postMessage({
				cmd: 'changeUrl',
				params: {
					success: true,
					data: to.fullPath
				}
			}, '*');
		} catch {}
	}
	let userName = request.getUserName();
	if (!userName && to.name != 'error') {
		console.log("吉客号获取失败");
		next({
			name: 'error'
		});
	}

	// 商城准入检测
	if (to.name != 'login' && to.name != 'error' && !await checkInLimitJudge()) {
		return next({
			name: 'login',
			NAVTYPE: 'replace' // redirectTo
		});
	}

	// 需要在进入页面之前获取的配置
	await getParamBeforeLoad();

	// 页面跳转
	next();

	// 根据版本号 判断是否需要刷新
	let newPcmallVersion = await utils.getSysSetting("pcmall_version");
	location.href.includes("/jmc/pcmall") && (!localStorage.getItem("pcmall_version") || newPcmallVersion != localStorage.getItem("pcmall_version")) && window.location.reload();
})

async function getParamBeforeLoad() {
	// 可以做到在进入页面前加载完配置
	let paramList = await getParam('isOpenLoginLimit,loginLimitType,isOpenShowVisitorPrice,decimalKeepPlaces,restricted_explainText,isOpenZeroStockBuy,pcmall_logo,isShowGoodsLongWidthHeight,isShowGoodsWeight,isShowGoodsVolume,pcmall_title,isShowGoodsDetailWithLimit');

	// 游客展示价 （开启 限制登录允许查看价格 相当于 关闭游客展示价）
	localStorage.setItem('isOpenShowVisitorPrice', !(paramList.isOpenLoginLimit == '1' && paramList.loginLimitType == 'auditLimitOfPrice') && paramList.isOpenShowVisitorPrice != '0' ? '1' : '0');

	// 小数保留位数
	localStorage.setItem('decimalKeepPlaces', paramList.decimalKeepPlaces || 2);

	// 区域限购提示
	localStorage.setItem('restricted_explainText', paramList.restricted_explainText || '');

	// 负库存下单
	localStorage.setItem('isOpenZeroStockBuy', paramList.isOpenZeroStockBuy);
	
	// 是否可见商品主图和详情
	localStorage.setItem('isShowGoodsDetailWithLimit', paramList.isOpenLoginLimit == '1' && paramList.loginLimitType == 'auditLimitOfPrice' && paramList.isShowGoodsDetailWithLimit == '0' ? '0' : '1');
	
	if (isFirsrLoad) {
		// 浏览器页签图标
		setFavicon(paramList)
	}
	isFirsrLoad = false;
}

/**
 * 浏览器页签图标
 */
function setFavicon(paramList) {
	document.getElementById('favicon').href = !!paramList.pcmall_logo && !paramList.pcmall_logo.includes('model_ads') ? paramList.pcmall_logo : 'https://web.jackyun.com//login/img/favicon.ico'
	// 域名转发时 传递favicon
	!!paramList.pcmall_logo && window.parent.postMessage({ type: 'favicon', url: paramList.pcmall_logo , mallName: paramList.pcmall_title || 'JMALL商城'}, '*')
}

/**
 * 商城准入校验
 */
async function checkInLimitJudge() {
	// 获取配置 以及 客户信息
	let paramList = await getParam('isOpenLoginLimit,loginLimitType,loginForMemberGradeId');
	let loginLimitType = paramList.loginLimitType;
	let isOpenLoginLimit = paramList.isOpenLoginLimit == '1';
	let loginForMemberGradeId = paramList.loginForMemberGradeId;

	let customerInfo = await getCustomerInfo();
	let isAlreadyHadCustomerInfo = !!customerInfo && !!customerInfo.phone;

	// 黑名单用户 不允许进入商城
	if ((customerInfo.error || "").includes("黑名单")) {
		return false;
	}

	// 没开启限制登录设置允许进入商城
	if (!isOpenLoginLimit || ['auditLimitOfPrice', 'auditLimitOfPersonalInfo'].includes(loginLimitType)) {
		return true;
	}

	// 没有客户档案信息
	if (!isAlreadyHadCustomerInfo) {
		return false;
	}

	// 检测处理异常会员等级情况，空数据影响判断结果
	let memberGradeId = customerInfo.vipLevel == '0' || !customerInfo.vipLevel ? '*****' : customerInfo.vipLevel;
	if (loginLimitType == 'memberGradeLimit' && isAlreadyHadCustomerInfo && !!loginForMemberGradeId && loginForMemberGradeId != "all" && (loginForMemberGradeId.indexOf(memberGradeId) < 0)) {
		return false;
	}

	return true;
}

new Vue({
	router: router, // 使用路由对象
	render: h => h(App),
}).$mount('#app')